import { createUseStyles } from 'react-jss'
import style from './style'

const useStyles = createUseStyles(style)

const Certifications = ({ items }) => {
  const classes = useStyles()
  return items.length > 0 ? (
    <div className={classes.root}>
      {/* <h2 className={classes.title}>Certificazioni</h2> */}
      <ul className={classes.section}>
        {items.map((certification, index) => (
          <li
            key={index.toString()}
          >
            <h3>{certification.title}</h3>
            <div className={classes.items}>
              {certification.file_list.length > 0 ? certification.file_list.map((item, i) => (item.file.url ? (
                <a
                  key={i.toString()}
                  href={item.file.url}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {item.logo?.url ? (
                    <div className={classes.logo}>
                      <img src={item.logo.url} alt={item.logo.title} />
                    </div>
                  ) : null}
                  <span>
                    <svg><use xlinkHref="#ico-download" /></svg>
                    {item.filename}
                  </span>
                </a>
              ) : null)) : null}
            </div>
          </li>
        ))}
      </ul>
    </div>
  ) : null
}

export default Certifications
